/*
* COPYRIGHT. HSBC HOLDINGS PLC 2017. ALL RIGHTS RESERVED.

* This software is only to be used for the purpose for which it has been
* provided. No part of it is to be reproduced, disassembled, transmitted,
* stored in a retrieval system nor translated in any human or computer
* language in any way or for any other purposes whatsoever without the
* prior written consent of HSBC Holdings plc.

*/
/**
 * author: tman
 */

import React from 'react';
import PropTypes from 'prop-types';

const CardList = (props) => {
    const { content, handelCardItem, questionId, questionIndicator } = props;
    const status = content.isComplete ? 'icon-circle-confirmation-solid' : 'icon-circle-error-solid';
    const isNoIcon = (content.isComplete || content.isIncomplete || content.isFail || content.isChecked) ? '' : 'no-icon';
    return (
        <div className="card-list-item" role="presentation">
            <a role="menuitem" href={''} title={ content.title.text }  onClick={event=>handelCardItem(event, questionId, questionIndicator)}>
                <h4 aria-hidden="true" data-key={ content.title.dataKey }>{ content.title.text }</h4>

                { (content.isComplete || content.isIncomplete) &&
                <div aria-hidden="true" className="item-status font-body3" data-key={content.statusTitle.dataKey}>
                    { content.statusTitle.text }<i className={`icon ${status}`}>{}</i>
                </div>
                }
                { content.isFail &&
                <div aria-hidden="true" className="item-status fail font-body3" data-key={content.statusTitle.dataKey}>
                    { content.statusTitle.failText }<i className={`icon icon-delete`}>{}</i>
                </div>
                }
                { content.isChecked &&
                <div aria-hidden="true" className="item-status checked font-body3" data-key={content.statusTitle.dataKey}>
                    { content.statusTitle.checkText }<i className={`icon icon-circle-error-solid`}>{}</i>
                </div>
                }
                <div aria-hidden="true" className={`item-icon ${isNoIcon}`}>
                    <i className="icon icon-chevron-right">{}</i>
                </div>
            </a>
        </div>
    )
};

CardList.propTypes = {
    content: PropTypes.object.isRequired,
    index: PropTypes.number,
    handelCardItem: PropTypes.func,
    questionId: PropTypes.string
};

CardList.defaultProps = {
    content: {}

};

export default CardList;



// WEBPACK FOOTER //
// ./src/views/AOFormReview/components/CardList/index.js